import React, { useCallback, useState, useRef, lazy } from 'react';
import { MoveHorizontalIcon } from 'lucide-react';
type Props = {
  before: string;
  after: string;
  label?: string;
};
export function BeforeAfter({
  before,
  after,
  label
}: Props) {
  const ref = useRef<HTMLDivElement>(null);
  const [pos, setPos] = useState(50);
  const dragging = useRef(false);
  const update = useCallback((clientX: number) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const p = (clientX - rect.left) / rect.width * 100;
    setPos(Math.max(2, Math.min(98, p)));
  }, []);
  return <div ref={ref} data-cursor="image" className="relative aspect-[4/3] w-full select-none overflow-hidden rounded-[2rem] shadow-glow" onMouseMove={e => dragging.current && update(e.clientX)} onMouseDown={e => {
    dragging.current = true;
    update(e.clientX);
  }} onMouseUp={() => dragging.current = false} onMouseLeave={() => dragging.current = false} onTouchMove={e => update(e.touches[0].clientX)} data-id="element-166" data-mp="2q9u1rgfctxe6">
      <img src={after} alt="After restoration" loading="lazy" decoding="async" className="absolute inset-0 h-full w-full object-cover" data-id="element-167" data-mp="1c4gt6n0dxz68" />
      <span className="absolute right-4 top-4 rounded-full bg-success/90 px-3 py-1 text-xs font-bold text-white" data-id="element-168" data-mp="y70nxettsbg2">
        AFTER
      </span>
      <div className="absolute inset-0 overflow-hidden" style={{
      width: `${pos}%`
    }} data-id="element-169" data-mp="oemj2d7gaopo">
        <img src={before} alt="Before restoration" loading="lazy" decoding="async" className="absolute inset-0 h-full w-full object-cover brightness-90 grayscale-[0.15]" style={{
        width: ref.current?.offsetWidth || '100%',
        maxWidth: 'none'
      }} data-id="element-170" data-mp="t75xtdhvjpw2" />
        <span className="absolute left-4 top-4 rounded-full bg-navy/80 px-3 py-1 text-xs font-bold text-white" data-id="element-171" data-mp="aetxsxep10p3">
          BEFORE
        </span>
      </div>

      {/* handle */}
      <div className="absolute inset-y-0" style={{
      left: `${pos}%`
    }} data-id="element-172" data-mp="2c6dilh916mpi">
        <div className="absolute inset-y-0 -translate-x-1/2 w-0.5 bg-white/90 shadow-[0_0_10px_rgba(0,87,255,0.5)]" data-id="element-173" data-mp="23byy909n8lzj" />
        <div className="absolute top-1/2 -translate-x-1/2 -translate-y-1/2 flex h-11 w-11 items-center justify-center rounded-full bg-white text-royal shadow-glow" data-id="element-174" data-mp="1yde7drga7enr">
          <MoveHorizontalIcon className="h-5 w-5" data-id="element-175" data-mp="2v0sm9k6af3jo" />
        </div>
      </div>

      {label && <div className="glass-strong absolute bottom-4 left-4 rounded-full px-4 py-2 text-xs font-semibold text-navy" data-id="element-176" data-mp="2qzfidfmr9afe">
          {label}
        </div>}
    </div>;
}